export interface GlobalFilterValues {
  state?: string
  issuerId?: string
  hiosPlanId?: string
}

export interface PlanBenefitFilterParams {
  state?: string
  hiosPlanId?: string
}

export interface PlansAndRatesFilterParams {
  state?: string
  hiosPlanId?: string
}

export interface ServiceAreasFilterParams {
  state?: string
  issuerId?: string
  hiosPlanId?: string
}

export interface SmokerRatesFilterParams {
  state?: string
  issuerId?: string
}

export interface LocationsFilterParams {
  state?: string
  issuerId?: string
  hiosPlanId?: string
}

export interface MappedFilterParams {
  planBenefits: PlanBenefitFilterParams
  plansAndRates: PlansAndRatesFilterParams
  serviceAreas: ServiceAreasFilterParams
  smokerRates: SmokerRatesFilterParams
  locations: LocationsFilterParams
}

/**
 * Maps global filter values to per-API query params.
 *
 * - issuerId = first 5 digits of a HIOS Plan ID.
 * - For APIs without an `issuerId` column (Plan Benefits, Plans & Rates),
 *   issuerId is sent as `hiosPlanId` (BE does prefix match).
 * - When both issuerId and hiosPlanId are set, hiosPlanId wins for APIs
 *   that only have a `hiosPlanId` param (it's more specific).
 */
export function mapGlobalFilters(
  filters: GlobalFilterValues
): MappedFilterParams {
  const { state, issuerId, hiosPlanId } = filters

  const resolvedHiosPlanId = hiosPlanId ?? issuerId

  return {
    planBenefits: {
      state,
      hiosPlanId: resolvedHiosPlanId,
    },
    plansAndRates: {
      state,
      hiosPlanId: resolvedHiosPlanId,
    },
    serviceAreas: {
      state,
      issuerId,
      hiosPlanId,
    },
    smokerRates: {
      state,
      issuerId,
    },
    locations: {
      state,
      issuerId,
      hiosPlanId,
    },
  }
}
